import { useUser } from 'src/utils/authentication';

export function useIsHead(userIn = undefined) {
  const { data } = useUser();

  const user = userIn || data;

  return user?.company?.type === 'head';
}
